'use client';

import { type RefObject, createContext, useContext } from 'react';

type TextFieldType = 'text' | 'email' | 'password' | 'url' | 'search';

interface TextFieldInternalContextValue {
  inputId?: string;
  inputRef: RefObject<HTMLInputElement | null>;
  value: string;
  setValue: (value: string) => void;
  type: TextFieldType;
  setType: (type: TextFieldType) => void;
  isDisabled?: boolean;
}

const TextFieldInternalContext =
  createContext<TextFieldInternalContextValue | null>(null);

function useTextFieldInternalContext(): TextFieldInternalContextValue {
  const context = useContext(TextFieldInternalContext);
  if (context === null) {
    throw new Error(
      'TextField sub-components must be used within a TextField.'
    );
  }
  return context;
}

export {
  TextFieldInternalContext,
  useTextFieldInternalContext,
  type TextFieldType,
};
